// -----------------------------------------------------------------------------
// src/Components/SendOfferDialog.js (UPDATED)
// -----------------------------------------------------------------------------
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import UnifiedOfferWizard from '../../../../../PartnershipsDeliverablesBookings/unifiedbookingwizard';

/**
 * SendOfferDialog - For internal/authenticated offer creation within partnerships
 * 
 * PROPS:
 * - open: boolean - Dialog open state
 * - onClose: function - Close callback
 * - partnershipId: string - ID of existing partnership
 * - creatorId: string - Creator ID
 * - conversationId: string - Conversation ID (optional)
 * - creator: object - Creator object for display
 * - onOfferSent: function - Callback when offer is sent
 */
const SendOfferDialog = ({ 
  open, 
  onClose, 
  partnershipId, 
  creatorId, 
  conversationId, 
  creator,
  onOfferSent 
}) => {
  // Create a creator object if only creatorId is provided
  const creatorObj = creator || {
    creator: creatorId,
    display_name: creatorId,
    pfphref: null
  };

  const handleComplete = (data) => {
    onClose();
    onOfferSent?.(data);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 4,
          width: 'min(800px, 90vw)',
          minHeight: '70vh',
          maxHeight: '85vh',
          overflow: 'hidden',
          backgroundColor: '#faf9f7',
          boxShadow: '0 28px 72px rgba(15, 23, 42, 0.18)',
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: '#ffffff',
          color: 'text.primary',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid',
          borderColor: alpha('#0f172a', 0.08),
          py: 2,
          px: 3,
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 800, fontSize: '1.25rem', lineHeight: 1.2, color: '#1c1917' }}>
            Send New Offer
          </Typography>
          <Typography variant="body2" sx={{ color: '#7a6662', mt: 0.25, fontSize: '0.85rem' }}>
            Create an offer within this partnership
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: 'text.secondary',
            bgcolor: alpha('#0f172a', 0.04),
            border: '1px solid',
            borderColor: alpha('#0f172a', 0.08),
            '&:hover': {
              bgcolor: alpha('#a00012', 0.08),
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          p: 0,
          bgcolor: 'transparent',
          '&::-webkit-scrollbar': { width: 8 },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: alpha('#0f172a', 0.16),
            borderRadius: 999,
          },
        }}
      >
        <UnifiedOfferWizard
          creator={creatorObj}
          isExternal={false}
          isCelebrity={false}
          partnershipId={partnershipId}
          conversationId={conversationId}
          onComplete={handleComplete}
          onCancel={onClose}
          isInDialog
        />
      </DialogContent>
    </Dialog>
  );
};

export default SendOfferDialog;
